import React from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import getLastPathSegment from '../../helpers/getPathSegment';

function ServiceCard({
  image, title, btnText, imgAlt, link,
}) {
  const navigate = useNavigate();
  const lang = Cookies.get('i18next') || 'en';
  const [first, ...rest] = (title || '').split(' ');
  const second = rest.join(' ');
  return (
    <figure className="our_services__card">
      <img src={image} alt={imgAlt || (`${first} ${second}`)} />
      <figcaption className="our_services__card_info">
        <p className="our_services__card_info-title">
          {first}
          <br />
          {second}
        </p>
        <button onClick={() => navigate(`/${lang}/${getLastPathSegment(link)}`)} className="our_services__card_info-link" type="button">{btnText}</button>
      </figcaption>
    </figure>
  );
}

export default ServiceCard;
